import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { UtilisateurCourantContext } from 'context/UtilisateurCourantContext';

// UNLEASH - on pousse l'utilisateur courant dans le contexte Unleash pour que les
// stratégies ciblant un userId puissent matcher (sinon les flags sont évalués sans
// utilisateur tant qu'on n'a pas visité l'admin Feature Flags).
import { useUnleashContext } from '@unleash/proxy-client-react';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';

import NavBarTabs from './NavBarTabs';
import NavBarUser from './NavBarUser';
import NavBarUserMenu from './NavBarUserMenu';


const NavBar = ({ logout, isLoginPage }) =>
{
    // Utilisateur courant depuis le context
    const { utilisateur } = useContext(UtilisateurCourantContext);

    // UNLEASH
    const updateUnleashContext = useUnleashContext();

    useEffect(() => {
        updateUnleashContext({ userId: utilisateur?.id ? `${utilisateur.id}` : undefined });
    }, [utilisateur?.id, updateUnleashContext]);

    let environment = 'DEV';
    const hostname = window.location.hostname;
    if (hostname.includes("recette"))
    {
        environment = 'RECETTE';
    }
    else if (!hostname.includes("localhost") && !hostname.includes("dev"))
    {
        environment = 'PROD';
    }

    return (
        <AppBar
            position={isLoginPage ? "relative" : "fixed"}
            sx={{
                transition: 'all 0.3s ease-in-out',
            }}
        >
            <Toolbar>

                <Tooltip
                    title={`${process.env.REACT_APP_NAME} ${process.env.REACT_APP_VERSION}`}
                    placement={isLoginPage ? "bottom" : "left"}
                    disableFocusListener>
                    <img src="logo.svg" width="200" height="51" alt="Logo portail après-vente" />
                </Tooltip>

                {!isLoginPage && <NavBarTabs isConnected={ utilisateur ? true : false} />}

                {environment !== 'PROD' && (
                    <Box
                        sx={{
                            flexGrow: 5,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <p>{environment}</p>
                    </Box>
                )}

                { utilisateur && !isLoginPage && (
                    <Box
                        sx={{
                            flexGrow: 5,
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <NavBarUser utilisateur={utilisateur} />
                        <NavBarUserMenu logout={logout} />
                    </Box>
                )}

            </Toolbar>
        </AppBar>
    );
}

NavBar.propTypes = {
    logout: PropTypes.func.isRequired,
    isLoginPage: PropTypes.bool
};

export default NavBar;
